import { openBlock as n, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function i(r, t) {
  return n(), l("svg", o, [...t[0] || (t[0] = [
    e("path", {
      d: "M18 3C12.477 3 8 7.477 8 13V23H12V13C12 9.687 14.686 7 18 7C21.314 7 24 9.687 24 13V23H28V13C28 7.477 23.523 3 18 3Z",
      fill: "#AAB8C2"
    }, null, -1),
    e("path", {
      d: "M31 32C31 34.209 29.209 36 27 36H9C6.791 36 5 34.209 5 32V20C5 17.791 6.791 16 9 16H27C29.209 16 31 17.791 31 20V32Z",
      fill: "#FFAC33"
    }, null, -1)
  ])]);
}
const c = { render: i };
export {
  c as default,
  i as render
};
